import { Exclude, Expose, Type } from 'class-transformer';
import { IsEnum, IsInt, IsISO8601, IsNumber, Max, ValidateNested } from 'class-validator';

import { BaseModel } from '@core/data-access';

import { FlattenObject, MyInfoAddress } from '../util';
import { MyInfoAddressNonSG, MyInfoAddressSG } from './address.model';
import { RemainingDate } from './remaining-date.model';

export enum HDBOwnershipType {
  T111 = '111',
  T112 = '112',
  T113 = '113',
  T114 = '114',
  T115 = '115',
  T116 = '116',
  T117 = '117',
  T118 = '118',
}

@Exclude()
export class HDBOwnership extends BaseModel {
  @Expose()
  @FlattenObject('value')
  @Max(9)
  noofowners!: number;

  @Expose()
  @MyInfoAddress()
  @ValidateNested()
  address!: MyInfoAddressSG | MyInfoAddressNonSG;

  @Expose()
  @FlattenObject('code')
  @IsEnum(HDBOwnershipType)
  hdbtype!: HDBOwnershipType;

  @Expose()
  @FlattenObject('value')
  @IsISO8601()
  leasecommencementdate!: string;

  @Expose()
  @FlattenObject('value')
  @IsInt()
  @Max(99)
  termoflease!: number;

  @Expose()
  @FlattenObject('value')
  @IsISO8601()
  dateofpurchase!: string;

  @Expose()
  @FlattenObject('value')
  @IsISO8601()
  dateofownershiptransfer!: string;

  @Expose()
  @FlattenObject('value')
  @IsNumber({ allowNaN: false, allowInfinity: false })
  loangranted!: number;

  @Expose()
  @FlattenObject('value')
  @IsInt()
  @Max(99)
  originalloanrepayment!: number;

  @Expose()
  @Type(() => RemainingDate)
  @ValidateNested()
  balanceloanrepayment!: RemainingDate;

  @Expose()
  @FlattenObject('value')
  @IsNumber({ allowNaN: false, allowInfinity: false })
  outstandingloanbalance!: number;

  @Expose()
  @FlattenObject('value')
  @IsNumber({ allowNaN: false, allowInfinity: false })
  monthlyloaninstalment!: number;

  @Expose()
  @FlattenObject('value')
  @IsNumber({ allowNaN: false, allowInfinity: false })
  outstandinginstalment!: number;

  @Expose()
  @FlattenObject('value')
  @IsNumber({ allowNaN: false, allowInfinity: false })
  purchaseprice!: number;
}
